import { Tooltip } from "@/components/ui/tooltip";
import { CashRequestStatus } from "@/constants/entity-status";
import { CashRequestEntity } from "@/pages/requests/cash/schema/cash-requests.schema";
import { AppColors } from "@/styles/colors";
import { Badge, Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: CashRequestEntity;
  handleDetail: (id: any) => void;
}

export const CashRequestActions = ({ handleDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item?.id)}
          data-testid="cash-request-actions-eye"
        />
        {item?.estadoDescripcion === CashRequestStatus.NEEDS_INFO && (
          <Badge
            position="absolute"
            top="-4px"
            right="-4px"
            bg="red.500"
            color="white"
            fontSize="10px"
            px={1}
          >
            !
          </Badge>
        )}
      </Flex>
    </Tooltip>
  );
};
